import { initReplayTrigger } from './api/replay-trigger.js'
import { configureStore } from './configure-store.js'

/**
 * The app's singleton store (`@tunasong/redux/store`).
 *
 * Creating it and booting the replay trigger are module-load side effects, so they live behind their own
 * subpath: importing `@tunasong/redux` for a slice, hook or type no longer builds a store (GH #1916).
 */
export const rootStore = configureStore()

/**
 * Boot the offline-mode replay trigger. Drains the mutation queue once now,
 * then subscribes to `networkBus` ws status + browser online/offline events and
 * drains it again when we transition from offline → online. Idempotent.
 */
initReplayTrigger(rootStore)
